import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import { IAppRootState } from 'src/app/core/store';

import { timelineOriginalReducer } from './timeline.reducer';
import { TimelineMainSliceState, TimelineSliceKey } from './timeline.state';

export const TimelineFeatureKey = 'Timeline';

export interface TimelineFeatureState {
	[TimelineSliceKey]: TimelineMainSliceState;
}

export interface TimelineRootState extends IAppRootState {
	[TimelineFeatureKey]: TimelineFeatureState;
}

export const featureSelector =
	createFeatureSelector<TimelineFeatureState>(TimelineFeatureKey);

export const timelineReducers: ActionReducerMap<TimelineFeatureState> = {
	[TimelineSliceKey]: timelineOriginalReducer,
};
